import React, { useState } from "react";
import { connect } from "react-redux";
import { Card, Button, Alert } from "react-bootstrap";
import axios from "axios";
import { API } from "../../api";

function ChangePassword(props) {
  const [old_password, setOld_password] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState(null);

  const myError = (msg) => {
    setError(`${msg}`);
    setTimeout(() => {
      setError("");
    }, 2000);
  };

  const handelValidate = () => {
    if (String(password).trim() !== String(password2).trim()) {
      myError("New Password's Field's Didn't Match");
      return false;
    }
    if (String(password).trim().length < 8) {
      myError("Password Must Be Greater Than Or Equal To 8 Character");
      return false;
    }
    return true;
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    if (handelValidate()) {
      if (props.token) {
        axios
          .put(
            `${API}change_password/`,
            {
              old_password,
              password,
              password2,
            },
            { headers: { Authorization: `Bearer ${props.token}` } }
          )
          .then((res) => {
            // console.log("Password Change Successfully", res.data);
            myError("Password Change Successfully");
            setOld_password("");
            setPassword("");
            setPassword2("");
          })
          .catch((err) => {
            // console.log(err.response.data);
            myError("Old Password Didn't Match");
          });
      }
    }
  };

  return (
    <div className="container">
      <form onSubmit={handelSubmit}>
        <Card>
          <Card.Header className="fw-bold">Change Password</Card.Header>
          <Card.Body>
            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="floatingInput1"
                placeholder="Old Password"
                value={old_password}
                onChange={(e) => {
                  setOld_password(e.target.value);
                }}
              />
              <label htmlFor="floatingInput1">Old Password</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="floatingPassword2"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <label htmlFor="floatingPassword2">New Password</label>
            </div>
            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                id="floatingPassword3"
                placeholder="Confirm Password Again"
                value={password2}
                onChange={(e) => {
                  setPassword2(e.target.value);
                }}
              />
              <label htmlFor="floatingPassword3">Confirm Password Again</label>
            </div>
            <Button type="submit" className="px-5 mb-3 " variant="primary">
              Submit
            </Button>
            {error ? <Alert variant="danger">{error}</Alert> : false}
          </Card.Body>
        </Card>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.userDetails.token,
  };
};
export default connect(mapStateToProps)(ChangePassword);
